
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgForYou = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 106,
  height: 104,
  viewBox: "0 0 106 104"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M101.055 3.288-.187 103.562l.065-33.531a8.094 8.094 0 0 1 2.33-5.668L64.5 1.121A3.242 3.242 0 0 1 66.78.155l32.848-.289a1.999 1.999 0 0 1 2.018 1.982c.006.541-.208 1.06-.591 1.44z"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#FFF",
  fontSize: 14,
  fontWeight: "bold",
  transform: "rotate(-45 92.385 66.627)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 27.379,
  y: 22.743
}, "\u05D1\u05DE\u05D9\u05D5\u05D7\u05D3 \u05D1\u05E9\u05D1\u05D9\u05DC\u05DA")))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"106\" height=\"104\" viewBox=\"0 0 106 104\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g>\r\n                    <path fill=\"#000000\" d=\"M5.733.602l142.493.684L124.47 24.95c-1.503 1.497-3.533 2.345-5.655 2.36l-88.766.673c-.858.006-1.684-.328-2.296-.93L4.322 4.03c-.788-.774-.8-2.04-.025-2.828C4.675.815 5.193.6 5.733.602z\" transform=\"translate(-12 -254) translate(-9 233) rotate(-45 128.234 51.778) rotate(180 74.518 14.286)\"/>\r\n                    <text fill=\"#FFF\" font-size=\"14\" font-weight=\"bold\" transform=\"translate(-12 -254) translate(-9 233) rotate(-45 128.234 51.778)\">\r\n                        <tspan x=\"27.379\" y=\"22.743\">במיוחד בשבילך</tspan>\r\n                    </text>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/for-you.29a80e87d5dfb8c3fd04d68e3101e982.svg"),
        {
          React: SvgForYou,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      